import { render, staticRenderFns } from "./k-filter.vue?vue&type=template&id=5bb48e3c&scoped=true&"
import script from "./k-filter.vue?vue&type=script&lang=ts&"
export * from "./k-filter.vue?vue&type=script&lang=ts&"
import style0 from "./k-filter.vue?vue&type=style&index=0&id=5bb48e3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb48e3c",
  null
  
)

export default component.exports